import {
    ALL_ORGANIZATION_ID,
    ALL_PICKLEBALL_DRILL_CODES,
} from "./pickleballDrillSkills";

const toOrganizationId = (id) => {
    const numericId = Number(id);
    return Number.isNaN(numericId) ? id : numericId;
};

export default function buildPickleballDrillFilters({
    startDate,
    endDate,
    organizations,
    skillCodes,
}) {
    const filters = [];

    if (startDate) {
        filters.push({
            field: "created_at",
            op: "gte",
            value: `${startDate} 00:00:00`,
        });
    }

    if (endDate) {
        filters.push({
            field: "created_at",
            op: "lte",
            value: `${endDate} 23:59:59`,
        });
    }

    const orgIds = (organizations || [])
        .filter((org) => org && org.id !== ALL_ORGANIZATION_ID)
        .map((org) => toOrganizationId(org.id));

    if (orgIds.length > 0) {
        filters.push({
            field: "organization_id",
            op: "in",
            value: orgIds,
        });
    }

    const selectedCodes = (skillCodes || []).filter((code) =>
        ALL_PICKLEBALL_DRILL_CODES.includes(code)
    );

    if (selectedCodes.length === 0 || selectedCodes.length === ALL_PICKLEBALL_DRILL_CODES.length) {
        filters.push({
            field: "skill_code",
            op: "like",
            value: "pickleball_drill",
        });
    } else {
        filters.push({
            field: "skill_code",
            op: "in",
            value: selectedCodes,
        });
    }

    return filters;
}
